const emptyToUndefined = (value) => typeof value === "string" && value.trim() === "" ? undefined : value;

export { emptyToUndefined };
